<template>
  <div id="app-home">
    <div class="header">
      <div class="title-icon">
        <img class="title-img" src="@assets/images/icon_download.png" />
        <span class="text">下载中心</span>
      </div>
    </div>

    <div class="content">
      <div class="main-bg">
        <div class="download-btn">
          <div class="btn-list">
            <div class="btn" v-for="(item, index) in clientList" :key="index" @click="downloadClient(item)">
              <img :src="item.iconUrl" />
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="tools">
        <div class="tool-item" v-for="(item, index) in toolsList" :key="index">
          <div class="head text-ellipsis" :style="{ backgroundImage: `url(${item.headImage})` }" :title="item.title">
            {{ item.title }}
          </div>
          <ul class="soft-list">
            <li v-for="(s, i) in item.softList" :key="i" class="soft-item">
              <img class="image" :src="s.imageUrl" />
              <div class="name text-ellipsis" :title="s.name">{{ s.name }}</div>
              <img v-if="s.qrcodeImg" :src="s.qrcodeImg" class="qr-img" @click="downloadClient2(s)" />
              <div v-else class="btn" @click="downloadTools(s)">下载</div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="section">
        <div class="left">
          <div class="school-name">北京市第八中学</div>
          <div>
            地址：北京市西城区学院小街2号&nbsp;&nbsp;&nbsp;&nbsp;邮编：100033
          </div>
          <div>
            官网：http://www.no8ms.bj.cn&nbsp;&nbsp;&nbsp;&nbsp;备案号：<a style="color: #ffffff"
              href="https://beian.miit.gov.cn" target="_blank">京ICP备18028911号-1</a>
          </div>
          <div>北京八中云校园：http://www.bjbzszxy.cn</div>
        </div>
        <div class="right">
          <div>
            <img src="@assets/images/circle.png" />
            <span class="app-title">八中云校园</span>
            <img src="@assets/images/circle.png" />
          </div>
          <div class="school-qr">
            <div id="ios-qr"></div>
            <div class="title">
              <img src="@assets/images/apple-icon-white.png" />
              <span>iOS端下载</span>
            </div>
          </div>
          <div class="school-qr">
            <div id="android-qr"></div>
            <div class="title">
              <img src="@assets/images/android-icon-white.png" />
              <span>Android端下载</span>
            </div>
          </div>
          <div class="school-qr">
            <div class="window-wrap" @click="
              downloadTools({
                downloadUrl:
                  'https://www.bjbzszxy.cn/download/app/BJ8THSetup.exe',
              })
              ">
              <img src="@assets/images/win-load.png" />
            </div>
            <div class="title">
              <img src="@assets/images/window-icon-white.png" />
              <span>Windows下载</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="" :visible.sync="dialogQrShow" :close-on-click-modal="false" :close-on-press-escape="false">
      <div id="qrcode" ref="qrcodeRefs"></div>
      <div class="scan-code">请扫码下载</div>
    </el-dialog>

    <el-dialog title="" :visible.sync="dialogQrShow2" :close-on-click-modal="false" :close-on-press-escape="false">
      <img class="dialog-qrcode" :src="qrCodeUrl" />
      <div class="scan-code">请扫码下载</div>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
import { getAppLists } from "@/utils/request.js";

export default {
  name: "App",
  components: {},
  data() {
    return {
      clientList: [
        {
          name: "iOS端下载",
          iconUrl: require("@assets/images/apple-icon.png"),
          downloadUrl: "https://www.bjbzszxy.cn/download-ios/",
        },
        {
          name: "Android端下载",
          iconUrl: require("@assets/images/android-icon.png"),
          downloadUrl:
            "https://www.bjbzszxy.cn/download/app/bjbzyxy_android.apk",
        },
        {
          name: "Windows下载",
          iconUrl: require("@assets/images/window-icon.png"),
          downloadUrl: "https://www.bjbzszxy.cn/download/app/BJ8THSetup.exe",
        },
      ],
      headImageList: [
        require("@assets/images/titlebg_purple.png"),
        require("@assets/images/titlebg_blue.png"),
        require("@assets/images/titlebg_orange.png"),
        require("@assets/images/titlebg_red.png"),
        require("@assets/images/titlebg_green.png"),
      ],
      toolsList: [
        /*  {
          headImage: require('@assets/images/titlebg_purple.png'),
          title: '云校园教学',
          softList: [
            {
              imageUrl: require('@assets/images/balogo.png'),
              name: 'Windows版',
              downloadUrl: 'https://www.bjbzszxy.cn/download/app/BJ8THSetup.exe'
            },
            {
              imageUrl: require('@assets/images/balogo.png'),
              name: 'Android版',
              downloadUrl: 'https://www.bjbzszxy.cn/download/app/bjbzyxy_android.apk',
              qrcode: require('@assets/images/qr-icon.png')
            },
            {
              imageUrl: require('@assets/images/balogo.png'),
              name: 'IOS版',
              downloadUrl: 'https://www.bjbzszxy.cn/download-ios/',
              qrcode: require('@assets/images/qr-icon.png')
            },
            {
              imageUrl: require('@assets/images/zhihui.png'),
              name: '智慧课堂学生端',
              downloadUrl:
                'https://bj.download.cycore.cn/zhkt-app-manage-server/appManage/744/d5e20f9b26126c56a50ecf3d4c8a8a3e/xkt_greenclass_qzk5.exe'
            },
            {
              imageUrl: require('@assets/images/zhihui.png'),
              name: '智慧课堂教师端',
              downloadUrl:
                'https://bj.download.cycore.cn/zhkt-app-manage-server/appManage/746/2a529105fd2e7d748400fb0f29cb88f2/xkt_qzk5.exe'
            },
            {
              imageUrl: require('@assets/images/ketang.png'),
              name: '八中课堂助手',
              downloadUrl:
                'https://pj.bjbzszxy.cn/package/pc/%E5%85%AB%E4%B8%AD%E8%AF%BE%E5%A0%82%E5%8A%A9%E6%89%8B.exe'
            }
          ]
        },
        {
          headImage: require('@assets/images/titlebg_blue.png'),
          title: '安全上网',
          softList: [
            {
              imageUrl: require('@assets/images/google.png'),
              name: '谷歌浏览器',
              downloadUrl: 'http://www.google.cn/intl/zh-CN/chrome/'
            },
            {
              imageUrl: require('@assets/images/firefox.png'),
              name: '火狐浏览器',
              downloadUrl: 'http://www.firefox.com.cn/'
            }
          ]
        },
        {
          headImage: require('@assets/images/titlebg_orange.png'),
          title: '系统工具',
          softList: [
            {
              imageUrl: require('@assets/images/2345.png'),
              name: '2345看图王',
              downloadUrl: 'https://pic.2345.cc/'
            },
            {
              imageUrl: require('@assets/images/rar.png'),
              name: '压缩包',
              downloadUrl: 'https://zip.njzhqlkj.cn/'
            },
            {
              imageUrl: require('@assets/images/drive.png'),
              name: '驱动精灵',
              downloadUrl: 'http://www.drivergenius.com/'
            },
            {
              imageUrl: require('@assets/images/pdf.png'),
              name: 'PDF阅读器',
              downloadUrl: 'https://www.foxitsoftware.cn/'
            },
            {
              imageUrl: require('@assets/images/sougou.png'),
              name: '搜狗输入法',
              downloadUrl: 'https://shurufa.sogou.com/'
            }
          ]
        },
        {
          headImage: require('@assets/images/titlebg_red.png'),
          title: '互联网服务',
          softList: [
            {
              imageUrl: require('@assets/images/study.png'),
              name: '学习强国',
              downloadUrl: 'https://www.xuexi.cn/'
            },
            {
              imageUrl: require('@assets/images/chaochang.png'),
              name: '超常教育',
              downloadUrl: 'https://www.no8ms.bj.cn/cms/ccjy/'
            }
          ]
        },
        {
          headImage: require('@assets/images/titlebg_green.png'),
          title: '系统急救',
          softList: [
            {
              imageUrl: require('@assets/images/save.jpg'),
              name: '系统急救箱',
              downloadUrl: 'https://weishi.360.cn/jijiuxiang/index.html'
            },
            {
              imageUrl: require('@assets/images/360.png'),
              name: '360安全卫士',
              downloadUrl: 'https://weishi.360.cn/?source=homepage/'
            }
          ]
        } */
      ],
      dialogQrShow: false,
      qrCodeUrl: "",
      dialogQrShow2: false,
      baseUrl: "https://appsquare-szjz.jyyun.com",
    };
  },

  async created() {
    try {
      let res = await getAppLists();
      console.log("res===", res);
      if (res && res.code === "1") {
        const data = res.success ? res.data?.outputs?.rows : [];
        console.log("data===", data);
        let groupData = data.reduce((acc, cur) => {
          const existingItem = acc.find((el) => el.title === cur.category); // 软件分类
          const imageInfo = cur.icon ? JSON.parse(cur.icon) : ""; // 图标
          const imageUrl = imageInfo?.[0]?.url;
          const itemInfo = {
            ...cur,
            imageInfo,
            imageUrl: imageUrl ? this.baseUrl + imageUrl + '&publicPage=true' : "",
            name: cur.softwareName, // 软件名称
            downloadType: cur.downloadMethod, // 下载方式
            downloadUrl: this.getDownloadUrl(cur),
            qrcodeImg:
              cur.downloadMethod === "二维码扫码下载"
                ? require("@assets/images/qr-icon.png")
                : "", // 下载方式
          };
          if (existingItem) {
            existingItem.softList.push(itemInfo);
          } else {
            acc.push({
              title: cur.category, // 软件分类
              softList: [itemInfo],
            });
          }
          return acc;
        }, []);
        groupData.forEach((item, index) => {
          const idx = index % this.headImageList.length;
          // console.log("idx===", idx);
          item.headImage = this.headImageList[idx];
          item.softList = item.softList.sort(
            (a, b) => Number(a.sortOrder) - Number(b.sortOrder)
          );
        });
        this.toolsList = groupData;
        console.log("groupData===", groupData);
      }
    } catch (err) {
      console.log(err);
    }
  },

  async mounted() {
    await this.$nextTick();
    this.createBottomQrcode();
  },

  watch: {
    async dialogQrShow(val) {
      if (val) {
        await this.$nextTick();
        this.createQrcode();
      }
    },
  },

  methods: {
    getDownloadUrl(cur) {
      const downloadType = cur.downloadMethod; // 下载方式
      if (downloadType === "跳转下载链接") {
        return cur.downloadLink; // 下载链接
      } else if (downloadType === "二维码扫码下载") {
        const qrcodeDownloadInfo = cur.qrCode; // 二维码
        const qrcodeInfo = qrcodeDownloadInfo
          ? JSON.parse(qrcodeDownloadInfo)
          : "";
        const url = qrcodeInfo?.[0]?.url;
        return url ? this.baseUrl + url + '&publicPage=true' : "";
      } else {
        // 安装包直接下载
        const installedPackageDownloadInfo = cur.package; // 安装包
        const installedPackageInfo = installedPackageDownloadInfo
          ? JSON.parse(installedPackageDownloadInfo)
          : "";
        const url = installedPackageInfo?.[0]?.url;
        return url ? this.baseUrl + url + '&publicPage=true' : "";
      }
    },

    downloadTools(s) {
      s.downloadUrl && window.open(s.downloadUrl, "_blank");
    },

    downloadClient(item) {
      if (item.name === "Windows下载") {
        return this.downloadTools(item);
      }
      this.qrCodeUrl = item.downloadUrl;
      this.dialogQrShow = true;
    },

    downloadClient2(item) {
      debugger
      if (item.name === "Windows下载") {
        return this.downloadTools(item);
      }
      this.qrCodeUrl = item.downloadUrl;
      console.log("this.qrCodeUrl", this.qrCodeUrl);
      this.dialogQrShow2 = true;
    },

    createQrcode() {
      this.cleanQrCode();
      new QRCode("qrcode", {
        width: 300, // 设置宽度，单位像素
        height: 300, // 设置高度，单位像素
        text: this.qrCodeUrl, // 设置二维码内容或跳转地址
      });
    },

    cleanQrCode() {
      this.$refs.qrcodeRefs.innerHTML = "";
    },

    createBottomQrcode() {
      new QRCode("android-qr", {
        width: 72, // 设置宽度，单位像素
        height: 72, // 设置高度，单位像素
        text: "https://www.bjbzszxy.cn/download/app/bjbzyxy_android.apk", // 设置二维码内容或跳转地址
      });
      new QRCode("ios-qr", {
        width: 72, // 设置宽度，单位像素
        height: 72, // 设置高度，单位像素
        text: "https://www.bjbzszxy.cn/download-ios/", // 设置二维码内容或跳转地址
      });
    },
  },
};
</script>
<style lang="scss" scoped>
ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.text-ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.header {
  display: flex;
  // height: 120px;
  height: 60px;
  background: url("~@assets/images/bg_head.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  z-index: 99;

  .title-icon {
    width: 1200px;
    margin: auto;
    display: flex;
    align-items: center;

    .title-img {
      width: 32px;
      height: 32px;
    }

    .text {
      font-size: 26px;
      font-weight: 500;
      color: #ffffff;
      vertical-align: top;
      margin-left: 15px;
    }
  }
}

.content {
  // min-height: calc(100vh - 288px);
  min-height: calc(100vh - 228px);

  // transform: translateY(-60px);
  .main-bg {
    height: 26vw;
    min-height: 310px;
    background: url("~@assets/images/bg_main.png") no-repeat;
    background-size: 100%;
    background-position-y: -60px;

    .download-btn {
      position: relative;
      margin: auto;
      width: 1200px;
      height: 100%;

      .btn-list {
        position: absolute;
        bottom: 48%;
        left: 3%;

        .btn {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          width: 130px;
          height: 38px;
          margin-right: 30px;
          background: rgba(255, 255, 255, 0.65);
          border: 2px solid #368fff;
          border-radius: 26px;
          text-align: center;
          cursor: pointer;

          span {
            font-size: 14px;
            color: #368fff;
            margin-left: 5px;
          }

          &:hover {
            border-color: #0959ba;
          }
        }
      }
    }
  }

  .tools {
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    margin: -150px auto 0;
    position: relative;
    box-sizing: border-box;
    width: 1200px;
    padding: 20px;
    background: linear-gradient(180deg, #ffffff, rgba(255, 255, 255, 0));
    border-radius: 8px;
    box-shadow: 0px -2px 4px 0px #eef8fb;

    .tool-item {
      margin-right: 27.5px;
      margin-bottom: 27.5px;

      &:nth-child(5n) {
        margin-right: 0;
      }

      .head {
        background: no-repeat;
        background-size: 100% 100%;
        width: 210px;
        height: 32px;
        line-height: 32px;
        padding: 0 10px;
        color: #ffffff;
        box-sizing: border-box;
      }

      .soft-item {
        display: flex;
        align-items: center;
        width: 210px;
        height: 40px;
        font-size: 14px;

        .image {
          height: 30px;
          width: 30px;
        }

        .name {
          flex: 1;
          margin-left: 5px;
        }

        .btn {
          width: 40px;
          line-height: 24px;
          background: #ffffff;
          border: 1px solid #d9dce2;
          border-radius: 4px;
          text-align: center;
          cursor: pointer;
        }

        .qr-img {
          width: 24px;
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }
  }
}

.footer {
  height: 120px;
  opacity: 0.85;
  background: #2d2d2d;

  .section {
    display: flex;
    width: 1200px;
    height: 100%;
    margin: auto;

    .left {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: #ffffff;

      &>div {
        font-size: 14px;
        margin-bottom: 5px;
      }

      .school-name {
        font-size: 16px;
      }
    }

    .right {
      flex: 1;
      display: flex;

      &>div {
        flex: 1;
        display: flex;
        align-items: center;
        color: #ffffff;
      }

      .app-title {
        margin: -3px 10px 0;
      }

      .school-qr {
        flex-direction: column;
        justify-content: center;

        .title {
          display: flex;
          align-items: center;
          font-size: 12px;
          margin-top: 5px;

          img {
            margin-right: 4px;
          }
        }

        .window-wrap {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 72px;
          height: 72px;
          background-color: #e8f4ff;
          cursor: pointer;

          img {
            width: 48px;
            height: 48px;
          }
        }
      }
    }
  }
}

::v-deep .el-dialog {
  width: 400px;

  .el-dialog__headerbtn {
    font-size: 24px;
  }

  .el-dialog__body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

#qrcode {
  display: flex;
  justify-content: center;
}

.dialog-qrcode {
  width: 300px;
  height: 300px;
}

.scan-code {
  text-align: center;
  font-size: 16px;
  margin-top: 5px;
}
</style>
<style></style>
